import { useEffect } from "react";

function ScrollByArrow({ children }) {
    useEffect(() => {
      
        const handleKeyDown = (event) => {
          if (
            ["INPUT", "TEXTAREA", "SELECT"].includes(document.activeElement.tagName)
          ) {
            return;
          }
          switch (event.key) {
            case "ArrowUp":
              window.scrollBy({ top: -100, behavior: "smooth" });
              break;
            case "ArrowDown":
              window.scrollBy({ top: 100, behavior: "smooth" });
              break;
            case "ArrowLeft":
              window.scrollBy({ left: -100, behavior: "smooth" });
              break;
            case "ArrowRight":
              window.scrollBy({ left: 100, behavior: "smooth" });
              break;
            default:
              break;
          }
        };
      
        document.addEventListener("keydown", handleKeyDown);
      
        return () => {
          document.removeEventListener("keydown", handleKeyDown);
        };
      }, []);
      

  return <>{children}</>;
}

export default ScrollByArrow;
